import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { areEqual } from 'Utils/equalityChecks';
import { SpinnerBlock } from 'Components/SpinnerBlock';
import { locationsSelector } from 'Containers/RocketScan/MultiUnit/Locations/selectors';
import { ReportLocation } from 'Containers/ReportsAndDocuments';
import { propertySelector } from 'Containers/RocketScan/selectors';
import { listLocations } from 'Containers/RocketScan/MultiUnit/Locations/actions';

import { setSelectedReportLocations, setSelectedReportRooms } from 'Containers/ReportsAndDocuments/Reports/actions';
import classes from './reportLocations.module.css';

let initialLoad = false;

const ReportLocationsContainer = () => {
  const dispatch = useDispatch();

  const property = useSelector(propertySelector, areEqual);
  const locations = useSelector(locationsSelector, areEqual);

  useEffect(() => {
    if (property?.id && locations.length === 0) {
      dispatch(listLocations(property.id, 1, 30));
    }
  }, [property]);

  useEffect(() => {
    // On the first load, set all the locations and rooms to be selected...
    if (!initialLoad && locations.length > 0) {
      initialLoad = true;
      locations.forEach((location) => {
        dispatch(setSelectedReportLocations(location.id));
        location.rooms.forEach((room) => {
          dispatch(setSelectedReportRooms(room.id));
        });
      });
    }
  }, [locations]);

  return (
    <div className={classes.reportLocations}>
      {locations.length === 0 ? (
        <SpinnerBlock fetching /> // Render the spinner when locations.length is 0
      ) : (
        locations.map((location: any) => <ReportLocation key={location.id} location={location} />)
      )}
    </div>
  );
};

const ReportLocationsContainerMemo = memo(ReportLocationsContainer, areEqual);

export { ReportLocationsContainerMemo as ReportLocationsContainer };
